import styled from 'styled-components';

export const Wrapper = styled.div`
background-color: ${({theme}) => theme.color.white};
padding-bottom: ${({theme}) => theme.PADDING_BOTTOM_PAGE};

  .SelectStateButton {
    margin-bottom: 15px;
    border-bottom: 1px solid ${({theme}) => theme.color.light};
    padding-left: 15px;
    padding-right: 15px;
  }

  .ContainerTop {

    ._med-container {

      .ActivePromotionsButton {
        margin-bottom: 20px;
      }

      .ReactSlick {
        margin-bottom: 15px;
      }
    }
  }
`;

export const WrapperCategories = styled.div`
  padding-left: 0.9375rem;
  margin-bottom: 15px;

  .hdline {
    padding-right: 0.9375rem;
    margin-bottom: 5px;
  }
`;

export const WrapperPartners = styled.div`
    margin-top: 0;
    margin-bottom: 15px;

    .hdline {
      margin-bottom: 10px;
    }
`;

// * Products
export const Products = styled.div`
  margin-bottom: 15px;
  .hdline {
    margin-bottom: 10px;
  }

  .slick-slider.ReactSlick.slick-initialized {

    .slick-list {
      margin-left: -5px;
      padding-bottom: 0.625rem;
    }
  }
`;

// * Partners
export const Partners = styled.div`
  .slick-slider.ReactSlick.slick-initialized {
    .slick-list {
      padding-left: 0 !important;
      margin-left: -0.3125rem;
      padding-bottom: 0.625rem;
    }
  }

`;